import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as Plotly from 'plotly.js';
declare global {
  interface Window {
    Plotly: typeof Plotly;
  }
}
@Component({
  selector: 'app-plotly-bubble',
  templateUrl: './plotly-bubble.component.html',
  styleUrls: ['./plotly-bubble.component.css']
})
export class PlotlyBubbleComponent implements OnInit {
  @ViewChild("bubble", { static: true }) private bubble: ElementRef<HTMLElement>;
  @Input() bubbleData: any;
  // @Input() index:any;
  @Output() bubbleAction = new EventEmitter<any>();
  ngOnInit(): void { }  

  ngOnChanges(){
    if(this.bubbleData.length)
    setTimeout(() => {
    this._plotGraph();
    },0);
  }

  private _plotGraph(){

    // this.className = 'donut'+ JSON.stringify(this.index);
    window.Plotly.newPlot( 
      'bubble',
      // this.bubble.nativeElement, //viewchild element
      this.bubbleData, //data provided
      {
        margin: {"l": 0, "r": 0, "b": 0, "t": 0},
        height: 150,
        // sunburstcolorway: this.sunburstData[0].sunburstcolorway,
      width: this.bubbleData[0].width?this.bubbleData[0].width: 300,
      yaxis: {fixedrange: true,
        tickangle: -45,
        range: this.bubbleData[0].yrange,
        showgrid: this.bubbleData[0].showgrid, 
        zeroline: this.bubbleData[0].zeroline,
        visible: this.bubbleData[0].visible,
        showticklabels: this.bubbleData[0].showticklabels
      },
      xaxis : {fixedrange: true,
        range: this.bubbleData[0].xrange,
        showgrid: this.bubbleData[0].showgrid, 
        zeroline: this.bubbleData[0].zeroline,
        visible: this.bubbleData[0].visible,
        showticklabels: this.bubbleData[0].showticklabels
      },
      showlegend: this.bubbleData[0].legend,
      legend:{
        orientation:'h',
        x: 0.4, y: 1.2
      }
      },{displaylogo: false,
        displayModeBar: false,
        showSendToCloud: true});
      (document.getElementById('bubble') as any).on('plotly_click', (data:any)=>{
        this.bubbleAction.emit(data);
      });
  }
}

